import Axios, { type AxiosInstance } from 'axios'
import { type CommonHeaders, getCommonHeaders } from '../client/utilities.client-helper'
import { isProduction } from './environment'

let axios

function configureAxios () {
  if (isProduction()) {
    return Axios.create({
      baseURL: 'https://api.justo.cloud/op-inventory-bff/'
    })
  }

  return Axios.create({
    baseURL: 'https://stag.justo.cloud/op-inventory-bff/'
  })
}

function getAxiosInstance (): AxiosInstance {
  if (!axios) {
    axios = configureAxios()

    axios.interceptors.request.use(async(config) => {
      const headers: CommonHeaders = await getCommonHeaders()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.keys(headers).map(e => config.headers.set(e, headers[e]))
      return config
    })
  }

  return axios
}

export const axiosInstance = getAxiosInstance
